import { ApiCompleteLookYodaResponse } from '../../domain/models/complete-look-yoda.model';
import { ProductUid } from '../../domain/models/related-products.models';

export const completeLookYodaTransformer = (response: ApiCompleteLookYodaResponse): ProductUid[] => {
    return response.recommendations.map((respObject) => {
        const mcc = respObject.reference.split('-')[0];
        return {
            colorId: mcc.slice(-3),
            product_id: null,
            provider: 'YODA',
            relatedType: 'completatulook_yoda',
            uid: mcc.slice(0, -3).padStart(8, '0'),
        };
    }, []);
};
